import axios from "axios";
import { MyHomeExtAppApiUrl } from "../helpers/apiUrls";

export default axios.create({
  withCredentials: true,
  baseURL: MyHomeExtAppApiUrl,
});

export const axiosPrivate = axios.create({
  withCredentials: true,
  baseURL: MyHomeExtAppApiUrl,
});
